import { useNavigate, useParams } from 'react-router-dom';
import { ChannelForm } from './channelForm';
import { useMutation } from '@tanstack/react-query';
import { Separator } from '@/components/ui/separator';
import { updateChannelGuide, useChannelGuide } from '@/lib/api/channelGuide';
import { cloneDeep } from 'lodash';
import { ChannelGuide } from '@/lib/schema/channelGuide';

function submitChannel(data: ChannelGuide) {
  return updateChannelGuide(data.id!, data);
}

export function CreateChannel() {
  const { channelGuideId } = useParams<{ channelGuideId: string }>();
  const [channelGuide, isLoading] = useChannelGuide(channelGuideId);

  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: submitChannel,
    onSuccess: () => {
      navigate(-1);
    },
    onError: (error) => {
      console.error('Error creating TV controller:', error);
    },
  });

  const onSubmit = (data: any) => {
    const update: ChannelGuide = cloneDeep(channelGuide);
    update.channels.push(data);
    mutation.mutate(update);
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="w-full pb-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Create Channel</h1>
        </div>
      </div>

      <Separator className="my-6" />

      <ChannelForm
        channels={channelGuide.channels || []}
        mutation={mutation}
        onSubmit={onSubmit}
      />
    </div>
  );
}
